import React, { Suspense } from 'react';
import { Await, Navigate, useLoaderData } from 'react-router';
import style from './LoadingCcdReportPreview.module.scss';
import PropTypes from 'prop-types';

/**
 * LoadingCcdReportPreview.jsx
 *
 * @summary This component is page view for loading climate disclosure report preview page.
 *
 * This page only exists in preview app.
 */
function LoadingCcdReportPreview({ overrideMessage }) {
  const { redirectTo } = useLoaderData();
  const message = overrideMessage || 'Retrieving climate disclosure report preview...';
  document.title = message;

  const loading = (
    <div id={style.findingCCD}>
      <div id={style.spinnerHolder}>
        <span className="spinner">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </span>
      </div>

      <p id={style.message}>{message}</p>
    </div>
  );

  return (
    <Suspense fallback={loading}>
      <Await resolve={redirectTo}>
        {(navigateTo) => {
          return <Navigate to={navigateTo} replace={true} />;
        }}
      </Await>
    </Suspense>
  );
}

LoadingCcdReportPreview.propTypes = {
  overrideMessage: PropTypes.string,
};

export default LoadingCcdReportPreview;
